export default class ExecutaSQL {
    constructor(resource) {
        this._resource = resource('executasql_supo');
    }

    encodeSql(rsql) {
        try {
            return window.btoa(window.unescape(encodeURIComponent(rsql)));
        } catch (err) {
            void err;
            return window.btoa(rsql);
        }
    }

    get(rsql) {
        return this._resource
            .get(
                {
                    rsql: this.encodeSql(rsql)
                }
            )
            .then(res => res.json()
                , err => {
                    throw new Error(err.statusText)
                });
    }

    save(rsql) {
        return this._resource
            .save(
                {},
                {
                    rsql: this.encodeSql(rsql)
                }
            )
            .then(res => res.json()
                , err => {
                    throw new Error(err.statusText)
                });
    }
}
